module.exports = __webpack_public_path__ + "static/img/mendian.95dd8c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/mendian.png
// module id = UsAT
// module chunks = 1